// extracted by mini-css-extract-plugin
module.exports =  {"label":"_32bbee5fda--label--hoD4I"};